import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import CircularProgress from "@material-ui/core/CircularProgress";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import api from "api/index";
import { useAuth } from "context/AuthContext";

const styles = {
  errorMsg: { color: "#f44336", fontSize: "13px", marginBottom: "12px" },
  successMsg: { color: "#4caf50", fontSize: "13px", marginBottom: "12px" },
  formControl: { width: "100%", maxWidth: "360px" }
};

class PortalChangePasswordInner extends Component {
  state = { currentPassword: "", newPassword: "", confirmPassword: "", saving: false, error: null, success: null };

  handleSubmit = async () => {
    const { currentPassword, newPassword, confirmPassword } = this.state;
    if (!currentPassword || !newPassword) {
      this.setState({ error: "All fields are required." }); return;
    }
    if (newPassword !== confirmPassword) {
      this.setState({ error: "New password and confirmation do not match." }); return;
    }
    if (newPassword.length < 6) {
      this.setState({ error: "New password must be at least 6 characters." }); return;
    }
    this.setState({ saving: true, error: null });
    try {
      await api.post("/auth/change-password", { currentPassword, newPassword });
      this.setState({ saving: false, success: "Password updated successfully.", currentPassword: "", newPassword: "", confirmPassword: "" });
      const updatedUser = { ...this.props.auth.user, mustChangePassword: false };
      this.props.auth.login(this.props.auth.token, updatedUser);
      setTimeout(() => this.props.history.push("/portal/dashboard"), 1000);
    } catch (e) {
      this.setState({ error: e.response?.data?.message || "Failed to update password.", saving: false });
    }
  };

  render() {
    const { classes, auth } = this.props;
    const { currentPassword, newPassword, confirmPassword, saving, error, success } = this.state;

    return (
      <GridContainer>
        <GridItem xs={12} sm={8} md={6}>
          <Card>
            <CardHeader color="primary" style={{ margin: -8, padding: "24px 20px" }}>
              <h4 style={{ margin: 0, color: "#fff", fontWeight: "bold" }}>Change Password</h4>
              {auth.user?.mustChangePassword && (
                <p style={{ margin: "2px 0 0", color: "rgba(255,255,255,0.85)", fontSize: "13px" }}>
                  Your account was created with a temporary password. Please set a new one to continue.
                </p>
              )}
            </CardHeader>
            <CardBody>
              {error && <p className={classes.errorMsg}>{error}</p>}
              {success && <p className={classes.successMsg}>{success}</p>}

              <div className={classes.formControl}>
                <CustomInput
                  labelText="Current Password *"
                  id="currentPassword"
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    type: "password", value: currentPassword,
                    onChange: e => this.setState({ currentPassword: e.target.value, error: null })
                  }}
                />
                <CustomInput
                  labelText="New Password *"
                  id="newPassword"
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    type: "password", value: newPassword,
                    onChange: e => this.setState({ newPassword: e.target.value, error: null })
                  }}
                />
                <CustomInput
                  labelText="Confirm New Password *"
                  id="confirmPassword"
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    type: "password", value: confirmPassword,
                    onChange: e => this.setState({ confirmPassword: e.target.value, error: null })
                  }}
                />
                <Button color="primary" onClick={this.handleSubmit} disabled={saving} style={{ marginTop: "16px" }}>
                  {saving ? <CircularProgress size={18} style={{ color: "#fff" }} /> : "Update Password"}
                </Button>
              </div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

PortalChangePasswordInner.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired
};

const PortalChangePasswordStyled = withStyles(styles)(PortalChangePasswordInner);

function PortalChangePassword(props) {
  const auth = useAuth();
  return <PortalChangePasswordStyled {...props} auth={auth} />;
}

export default withRouter(PortalChangePassword);
